/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  filterUsers,
  fetchAssignedDistributors,
  assignDistributor,
  unAssignDistributor,
  updateUser,
} from '../actions/users.action';

const initialState = {
  users: null,
  userListStatus: 'idle',
  assignedDistributorStatus: 'idle',
  assignDistributorStatus: 'idle',
  unAssignDistributorStatus: 'idle',
  userUpdateStatus: 'idle',
};

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(filterUsers.fulfilled, (state, action) => {
        state.userListStatus = 'complete';
      })
      .addCase(filterUsers.pending, (state, action) => {
        state.userListStatus = 'loading';
      })
      .addCase(filterUsers.rejected, (state, action) => {
        state.userListStatus = 'failed';
      })
      .addCase(fetchAssignedDistributors.fulfilled, (state, action) => {
        state.assignedDistributorStatus = 'complete';
      })
      .addCase(fetchAssignedDistributors.pending, (state, action) => {
        state.assignedDistributorStatus = 'loading';
      })
      .addCase(fetchAssignedDistributors.rejected, (state, action) => {
        state.assignedDistributorStatus = 'failed';
      })
      .addCase(assignDistributor.fulfilled, (state, action) => {
        state.assignDistributorStatus = 'complete';
      })
      .addCase(assignDistributor.pending, (state, action) => {
        state.assignDistributorStatus = 'loading';
      })
      .addCase(assignDistributor.rejected, (state, action) => {
        state.assignDistributorStatus = 'failed';
      })

      .addCase(unAssignDistributor.fulfilled, (state, action) => {
        state.unAssignDistributorStatus = 'complete';
      })
      .addCase(unAssignDistributor.pending, (state, action) => {
        state.unAssignDistributorStatus = 'loading';
      })
      .addCase(unAssignDistributor.rejected, (state, action) => {
        state.unAssignDistributorStatus = 'failed';
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        state.userUpdateStatus = 'complete';
      })
      .addCase(updateUser.pending, (state, action) => {
        state.userUpdateStatus = 'loading';
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.userUpdateStatus = 'failed';
      });
  },
});

export default userSlice.reducer;
